import {
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Button,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { Icon } from "@iconify/react";
import emailFill from "@iconify/icons-eva/email-fill";
import { useSnackbar } from "src/components/snackbar";
import { useNotificarDatosFaltantesMutation } from "src/services/facturasApi";

export default function PanelOmitidos({
  sucursal,
  items,
  permiso,
  soloLectura,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [notificar, { isLoading }] = useNotificarDatosFaltantesMutation();
  const omitidos = items.filter((i) => i.estado === "OMITIDA");

  if (omitidos.length === 0) return null;

  const onAvisar = async () => {
    // El endpoint recibe un tipoFactura por llamada; agrupamos MES/AÑO.
    const grupos = { MES: [], AÑO: [] };
    omitidos.forEach((i) => {
      (grupos[i.tipoFrecuencia] ?? grupos.MES).push({ id: i.id });
    });
    try {
      let notificados = 0;
      const sinCorreo = [];
      for (const tipo of ["MES", "AÑO"]) {
        if (!grupos[tipo].length) continue;
        const res = await notificar({
          sucursal,
          tipoFactura: tipo,
          facturas: grupos[tipo],
        }).unwrap();
        notificados += res.notificados ?? 0;
        if (Array.isArray(res.clientesSinCorreo))
          sinCorreo.push(...res.clientesSinCorreo);
      }
      const extra = sinCorreo.length
        ? ` ${sinCorreo.length} cliente(s) sin correo registrado.`
        : "";
      enqueueSnackbar(`Se avisó a ${notificados} encargado(s).${extra}`, {
        variant: sinCorreo.length ? "warning" : "success",
      });
    } catch (e) {
      enqueueSnackbar("No se pudo enviar el aviso a los encargados.", {
        variant: "error",
      });
    }
  };

  return (
    <Card>
      <CardHeader
        title={`Omitidos (${omitidos.length})`}
        subheader="Planes que deberían facturarse pero les falta un dato (ej. RUT provisorio)."
        action={
          !soloLectura && permiso?.puedeNotificar ? (
            <Button
              startIcon={
                isLoading ? (
                  <CircularProgress size={18} />
                ) : (
                  <Icon icon={emailFill} />
                )
              }
              disabled={isLoading}
              onClick={onAvisar}
            >
              Avisar al encargado
            </Button>
          ) : null
        }
      />
      <CardContent>
        <List dense>
          {omitidos.map((i) => (
            <ListItem key={i.id} disableGutters>
              <ListItemText
                primary={`${i.nombreCliente} — ${i.nombrePlan}`}
                secondary={i.ultimoError || "Falta un dato para facturar"}
              />
              <Typography variant="caption" color="text.secondary">
                {i.tipoFrecuencia === "MES" ? "Mensual" : "Anual"}
              </Typography>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
